import angular from 'angular';

import TransactionModule from './transaction';

import BalanceService from './balance.service';
import CategoryService from './category.service';
import CalendardService from './calendar.service';
import SuggestionService from './suggestion.service';
import AutoCategoryService from './auto-category.service';
import MonitoringCategorizationService from './monitoring-categorization.service';

/* @ngInject */
export function appStartCacheRegistration(appStartCacheService, storageService, categoryService) {
    appStartCacheService.register('categories', {
        warm: () => {
            const teamId = storageService.getUserItem('selected-team');
            if (!teamId) {
                return null;
            }

            return categoryService.refresh(teamId);
        },
        clear: () => {
            appStartCacheService.clearUserKeyPrefix('categories');
        }
    });
}

export default angular
    .module('application.service.calendar', [
        TransactionModule.name
    ])
    .service('balanceService', BalanceService)
    .service('categoryService', CategoryService)
    .service('calendarService', CalendardService)
    .service('suggestionService', SuggestionService)
    .service('monitoringCategorizationService', MonitoringCategorizationService)
    .service('autoCategoryService', AutoCategoryService)
    .run(appStartCacheRegistration);



// WEBPACK FOOTER //
// ./src/application/service/calendar/index.js